// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "hotelfinder" + "." + "bd81e075e7024b064d22" + ".css";
};